import { IOnboardingStepProps } from "../Onboarding";

import { View } from "./View";

export const OnboardingOne = (props: IOnboardingStepProps) => {
  return <View onSubmit={props.handleNext} {...props} />;
};
